//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { InstagramPublishingStrategy } from '@models/InstagramPublishingStrategy';
import { ISchedulerDefaultPostingTime } from '@models/IUserSettings';
import UserId from '@models/UserId';

export enum INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS {
  REQUEST_DEFAULTS = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/REQUEST_DEFAULTS',
  RECEIVE_DEFAULTS_SUCCEEDED = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/RECEIVE_DEFAULTS_SUCCEEDED',
  RECEIVE_DEFAULTS_FAILED = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/RECEIVE_DEFAULTS_FAILED',

  SET_DEFAULT_USER_ID = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/SET_DEFAULT_USER_ID',
  CLEAR_DEFAULT_USER_ID = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/CLEAR_DEFAULT_USER_ID',

  SET_DEFAULT_POST_TIME = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/SET_DEFAULT_POST_TIME',
  CLEAR_DEFAULT_POST_TIME = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/CLEAR_DEFAULT_POST_TIME',

  SET_DEFAULT_PUBLISHING_STRATEGY = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/SET_DEFAULT_PUBLISHING_STRATEGY',

  REQUEST_SAVE_DEFAULTS = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/REQUEST_SAVE_DEFAULTS',
  RECEIVE_SAVE_DEFAULTS_SUCCEEDED = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/RECEIVE_SAVE_DEFAULTS_SUCCEEDED',
  RECEIVE_SAVE_DEFAULTS_FAILED = 'INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS/RECEIVE_SAVE_DEFAULTS_FAILED',
}

export interface IInstagramPostDefaults {
  defaultNotificationUserId?: UserId;
  defaultPostTime?: ISchedulerDefaultPostingTime;
  defaultPublishingStrategy?: InstagramPublishingStrategy;
}

export interface IInstagramPostDetailsDefaultsState {
  currentDefaults: IInstagramPostDefaults;
  newDefaults: IInstagramPostDefaults;
  flags: IInstagramPostDetailsDefaultsFlags;
}

interface IInstagramPostDetailsDefaultsFlags {
  isFetchingDefaults: boolean;
  isSavingDefaults: boolean;
}
